import styles from '../styles/Footer.module.scss';
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from 'react-router-dom';
import Gradient from "../imgs/gradient.svg";
import Gradient2 from "../imgs/gradient2.svg";

export default function Footer() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
      <div>
        <div className={styles.footer}>

<div className={styles.section1}>
  <h1>{t("Begin Your Journey to Trading Excellence")}</h1>
  <span>{t("Take the leap towards trading greatness now")}</span>
  <div onClick={() => navigate('/login')} className={styles.button}>
    {t("Start now")}
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M4.5 4L12.5 12M12.5 12L12.5 6M12.5 12L6.5 12"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="square"
      />
    </svg>
  </div>
</div>

<span>{t('Contact us')}</span>
        <div className={styles.top}>
          <Link to='/accounts'>{t("Account Types")}</Link>
          <Link to='/tools/forexHeatMap'>{t("Instruments")}</Link>
          <Link to='/bonuses'>{t("Promotion and bonuses")}</Link>
          <Link to='/about'>{t("About us")}</Link>
          <span className={styles.left_side}>
              {t("© 2024 Synergy Assets")}
            </span>
        </div>
        {/* {window.innerWidth > 600 ? (
          <div className={styles.bottom}>
            <span className={styles.left_side}>
              {t("© 2024 Synergy Assets")}
            </span>
            <div className={styles.right_side}>
              <span>{t("All Rights Reserved")}</span>
              <span>{t("Privacy Notice")}</span>
              <span>{t("Legal")}</span>
              <span>{t("Site map")}</span>
            </div>
          </div>
        ) : (
          <div className={styles.bottom}>
            <div className={styles.right_side}>
              <span>{t("All Rights Reserved")}</span>
              <span>{t("Privacy Notice")}</span>
              <span>{t("Legal")}</span>
              <span>{t("Site map")}</span>
            </div>
            <span className={styles.left_side}>
              {t("© 2024 Synergy Assets")}
            </span>
          </div>
        )} */}
      </div>
      </div>
    )
}